<template>
  <div id="app">
    <jm-nav></jm-nav>
    <jm-top-banner>   </jm-top-banner>
    <jm-collumns>     </jm-collumns>
    <jm-mid-banner>   </jm-mid-banner>
    <jm-network id="network" class="hide-on-med-and-up"> </jm-network >
    <jm-network class="hide-on-small-only"> </jm-network >
    <jm-foot-banner>  </jm-foot-banner>
    <jm-footer>       </jm-footer>
    <jm-modal>        </jm-modal>
  </div>
</template>

<script>
import JmNav from './components/jm-a-nav.vue'

import JmTopBanner from './components/jm-b-top-banner.vue'

import JmBlog from './components/jm-c-blog.vue'

import JmCollumns from './components/jm-d-collumns.vue'

import JmMidBanner from './components/jm-e-mid-banner.vue'

import JmContact from './components/jm-f-contact.vue'

import JmNetwork from './components/jm-g-network.vue'

import JmFootBanner from './components/jm-h-foot-banner.vue'

import JmFooter from './components/jm-i-footer.vue'

import JmModal from './components/common/jm-modal.vue'

export default {
  name: 'app',
  components: {
    JmNav,
    JmTopBanner,
    JmBlog,
    JmCollumns,
    JmMidBanner,
    JmContact,
    JmNetwork,
    JmFootBanner,
    JmFooter,
    JmModal
  }
}

$(document).ready(function () {
  $('.button-collapse').sideNav()
  $('.parallax').parallax()
  $('.modal').modal()
  $('.button-collapse').off('click').sideNav()
})

</script>

<style>
  #app {
    font-family: Arial,'Avenir', Helvetica, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;

  }

  .material-icons-align{
    float: left;
    line-height: 60px; 
  }  

  #sidenav-overlay{
    background:none;
  }
</style>
<style src="./assets/css/style.css"></style>



// WEBPACK FOOTER //
// App.vue?df540bd8